import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface LRSMarkdownProps {
    children: string;
}

const LRSMarkdown: React.FC<LRSMarkdownProps> = ({ children }) => {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                table: ({ children }) => (
                    <table style={{ borderCollapse: 'collapse', width: '100%', margin: '1em 0' }}>{children}</table>
                ),
                th: ({ children }) => (
                    <th
                        style={{
                            border: '1px solid #d0d7de',
                            padding: '8px 12px',
                            textAlign: 'left',
                            backgroundColor: '#f6f8fa',
                        }}
                    >
                        {children}
                    </th>
                ),
                td: ({ children }) => (
                    <td style={{ border: '1px solid #d0d7de', padding: '8px 12px', textAlign: 'left' }}>{children}</td>
                ),
            }}
        >
            {children}
        </ReactMarkdown>
    );
};

export default LRSMarkdown;
